import {
	BaseQueryFn,
	FetchArgs,
	fetchBaseQuery,
	FetchBaseQueryError,
	FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';

import { notification } from 'antd';

import { store } from 'app/appStore';
import { ERRORS } from 'shared/consts';
import { EErrorCodes, EMainRoutes, IBadRequestData } from 'shared/typings';

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta> = async (
	args,
	api,
	extraOptions,
) => {
	const result = await fetchBaseQuery({
		baseUrl: '/api/',
		prepareHeaders: (headers) => {
			return headers;
		},
	})(args, api, extraOptions);

	const statusCode = result.meta?.response?.status;
	const translations = store.getState().commonSlice.trans.errors;

	if (statusCode === EErrorCodes.UNAUTHORIZED || statusCode === EErrorCodes.FORBIDDEN) {
		window.location.replace(
			`/${EMainRoutes.ACCOUNT}/${EMainRoutes.LOG_IN}/?next=${encodeURIComponent(window.location.href)}`,
		);
	}

	if (
		statusCode === EErrorCodes.BAD_GATEWAY ||
		statusCode === EErrorCodes.INTERNAL_SERVER_ERRROR ||
		statusCode === EErrorCodes.PAGE_NOT_FOUND
	) {
		const text = result.meta?.response?.statusText;

		notification.open({
			message: `${statusCode} - ${text}`,
			type: 'error',
			placement: 'topRight',
			showProgress: true,
			pauseOnHover: true,
		});
	}

	if (statusCode === EErrorCodes.BAD_REQUEST) {
		const data = result.error?.data || {};

		if (typeof data === 'object') {
			Object.values({
				...data,
				...((data as Record<string, unknown>).website_data as object),
				...((data as Record<string, unknown>).influencer_data as object),
				...((data as Record<string, unknown>).arbitrage_data as object),
			}).forEach((value) => {
				if (Array.isArray(value)) {
					value.forEach((error) => {
						let errorText = '';

						if (typeof error === 'string') {
							errorText = translations[error as keyof ReturnType<typeof ERRORS>]?.() || error;
						}

						if (typeof error === 'object' && 'code' in error && 'detail' in error && 'additional_data' in error) {
							const errorObject = error as IBadRequestData;
							errorText = translations[errorObject.code]?.(error.additional_data) || errorObject.detail;
						}

						if (typeof error === 'object' && 'url' in error && Array.isArray(error.url)) {
							error.url.forEach((urlError: IBadRequestData) => {
								if (typeof urlError === 'string') {
									errorText = translations[urlError as keyof ReturnType<typeof ERRORS>]?.() || urlError;
								}

								if (
									typeof urlError === 'object' &&
									'code' in urlError &&
									'detail' in urlError &&
									'additional_data' in urlError
								) {
									errorText = translations[urlError.code]?.(urlError?.additional_data || undefined) || urlError.detail;
								}
							});
						}

						errorText &&
							notification.open({
								message: errorText,
								type: 'error',
								placement: 'topRight',
								showProgress: true,
								pauseOnHover: true,
							});
					});
				}
			});
		}
	}

	return result;
};
